/**
 * DS-04: the fixed English toasts the screens raise (about 180 calls, 140 distinct texts), in Arabic. ErpToastrService looks a
 * toast up here (case- and space-insensitive) when the screen is in Arabic, so no call site changes. New screens use translate
 * keys or this.t(en, ar) instead of adding here.
 */
const AR: Record<string, string> = {
  'Added Absent Successfully': 'تمت إضافة الغياب بنجاح',
  'Added Data successfully': 'تمت إضافة البيانات بنجاح',
  'Added Deduction Successfully': 'تمت إضافة الخصم بنجاح',
  'Added Successfully': 'تمت الإضافة بنجاح',
  'Added Vacation Type Successfully': 'تمت إضافة نوع الإجازة بنجاح',
  'Allowances Deleted': 'تم حذف البدلات',
  'Applicant registered successfully!': 'تم تسجيل المتقدم بنجاح!',
  'Attendance Standard Built Successfully': 'تم إنشاء معيار الحضور بنجاح',
  'Attendance updated successfully': 'تم تحديث الحضور بنجاح',
  'Category Details Saved Successfully': 'تم حفظ تفاصيل الفئة بنجاح',
  'Committee member deleted': 'تم حذف عضو اللجنة',
  'Committee saved successfully': 'تم حفظ اللجنة بنجاح',
  'Company ID is required': 'معرّف الشركة مطلوب',
  'Company System deleted successfully': 'تم حذف نظام الشركة بنجاح',
  'Company System status updated': 'تم تحديث حالة نظام الشركة',
  'Company System updated successfully': 'تم تحديث نظام الشركة بنجاح',
  'Could not download the template.': 'تعذر تنزيل القالب.',
  'Delete failed': 'فشل الحذف',
  'Delete operation did not complete successfully': 'لم تكتمل عملية الحذف بنجاح',
  'Deleted Employee Successfully': 'تم حذف الموظف بنجاح',
  'Deleted Successfully': 'تم الحذف بنجاح',
  'Deleted vacation request successfully': 'تم حذف طلب الإجازة بنجاح',
  'Department added': 'تمت إضافة القسم',
  'Department added successfully': 'تمت إضافة القسم بنجاح',
  'Detail Deleted Successfully': 'تم حذف التفصيل بنجاح',
  'Detail deleted': 'تم حذف التفصيل',
  'Details saved successfully': 'تم حفظ التفاصيل بنجاح',
  'Duties Saved Successfully': 'تم حفظ المهام بنجاح',
  'Duty Deleted Successfully': 'تم حذف المهمة بنجاح',
  'Error Deleting': 'حدث خطأ أثناء الحذف',
  'Error Deleting Aloowances': 'حدث خطأ أثناء حذف البدلات',
  'Error Loading Data': 'حدث خطأ أثناء تحميل البيانات',
  'Error Loading Job Duties': 'حدث خطأ أثناء تحميل مهام الوظيفة',
  'Error Loading Job Skills': 'حدث خطأ أثناء تحميل مهارات الوظيفة',
  'Error Loading Questions': 'حدث خطأ أثناء تحميل الأسئلة',
  'Error Saving Answers': 'حدث خطأ أثناء حفظ الإجابات',
  'Error Saving Data': 'حدث خطأ أثناء حفظ البيانات',
  'Error Saving Duties': 'حدث خطأ أثناء حفظ المهام',
  'Error Saving Procedures': 'حدث خطأ أثناء حفظ الإجراءات',
  'Error Saving Questions': 'حدث خطأ أثناء حفظ الأسئلة',
  'Error adding journal entry detail': 'حدث خطأ أثناء إضافة سطر القيد',
  'Error creating company system': 'حدث خطأ أثناء إنشاء نظام الشركة',
  'Error creating role-permission': 'حدث خطأ أثناء إنشاء صلاحية الدور',
  'Error deleting company system': 'حدث خطأ أثناء حذف نظام الشركة',
  'Error deleting detail': 'حدث خطأ أثناء حذف التفصيل',
  'Error deleting member': 'حدث خطأ أثناء حذف العضو',
  'Error deleting role-permission': 'حدث خطأ أثناء حذف صلاحية الدور',
  'Error loading accounts': 'حدث خطأ أثناء تحميل الحسابات',
  'Error loading attendance details': 'حدث خطأ أثناء تحميل تفاصيل الحضور',
  'Error loading branches': 'حدث خطأ أثناء تحميل الفروع',
  'Error loading committee': 'حدث خطأ أثناء تحميل اللجنة',
  'Error loading company systems': 'حدث خطأ أثناء تحميل أنظمة الشركة',
  'Error loading details': 'حدث خطأ أثناء تحميل التفاصيل',
  'Error loading roles permissions': 'حدث خطأ أثناء تحميل صلاحيات الأدوار',
  'Error saving category details': 'حدث خطأ أثناء حفظ تفاصيل الفئة',
  'Error saving committee': 'حدث خطأ أثناء حفظ اللجنة',
  'Error saving details': 'حدث خطأ أثناء حفظ التفاصيل',
  'Error saving skills': 'حدث خطأ أثناء حفظ المهارات',
  'Error toggling branch status:': 'حدث خطأ أثناء تغيير حالة الفرع:',
  'Error updating attendance': 'حدث خطأ أثناء تحديث الحضور',
  'Error updating company system': 'حدث خطأ أثناء تحديث نظام الشركة',
  'Error updating role-permission': 'حدث خطأ أثناء تحديث صلاحية الدور',
  'Error updating status': 'حدث خطأ أثناء تحديث الحالة',
  'Error updating tax type status': 'حدث خطأ أثناء تحديث حالة نوع الضريبة',
  'Failed to delete': 'فشل الحذف',
  'Failed to load deduction data': 'تعذر تحميل بيانات الخصم',
  'Failed to load questions': 'تعذر تحميل الأسئلة',
  'Failed to load subscription plans': 'تعذر تحميل خطط الاشتراك',
  'Failed to update status': 'تعذر تحديث الحالة',
  'Invalid subscription ID': 'معرّف الاشتراك غير صالح',
  'Invalid user ID': 'معرّف المستخدم غير صالح',
  'Journal Entry added successfully': 'تمت إضافة القيد بنجاح',
  'Journal Entry updated successfully': 'تم تحديث القيد بنجاح',
  'Leave Request added successfully': 'تمت إضافة طلب الإذن بنجاح',
  'Leave Request updated successfully': 'تم تحديث طلب الإذن بنجاح',
  'Leave Type added successfully': 'تمت إضافة نوع الإذن بنجاح',
  'Login failed, please try again': 'فشل تسجيل الدخول، حاول مرة أخرى',
  'No Changes Detected To Update': 'لا توجد تغييرات للتحديث',
  'No Changes In Details To Save': 'لا توجد تغييرات في التفاصيل للحفظ',
  'No Data Found For The Selected Filters.': 'لا توجد بيانات للفلاتر المحددة.',
  'No changes detected': 'لا توجد تغييرات',
  'No changes to save': 'لا توجد تغييرات للحفظ',
  'No data available': 'لا توجد بيانات',
  'OTP verification failed': 'فشل التحقق من الرمز',
  'OTP verified successfully': 'تم التحقق من الرمز بنجاح',
  'Payroll could not be run': 'تعذر تشغيل مسير الرواتب',
  'Please Answer All Required Questions Before Saving': 'أجب عن جميع الأسئلة المطلوبة قبل الحفظ',
  'Please Enter Data Before Saving': 'أدخل البيانات قبل الحفظ',
  'Please Enter Data in Form and Details Table': 'أدخل البيانات في النموذج وجدول التفاصيل',
  'Please Enter Fields Before Proceeding To The Next Step': 'أكمل الحقول قبل الانتقال إلى الخطوة التالية',
  'Please Search Employees First': 'ابحث عن الموظفين أولاً',
  'Please Select At Least One Employee': 'اختر موظفاً واحداً على الأقل',
  'Please Select At Least One Filter Before Searching': 'اختر فلتراً واحداً على الأقل قبل البحث',
  'Please Select Both From Date and To Date': 'اختر تاريخ البداية وتاريخ النهاية',
  'Please Select Dates First': 'اختر التواريخ أولاً',
  'Please Select Shift First': 'اختر الوردية أولاً',
  'Please enter Arabic name': 'أدخل الاسم العربي',
  'Please enter English name': 'أدخل الاسم الإنجليزي',
  'Please enter the 4-digit OTP code': 'أدخل رمز التحقق المكون من 4 أرقام',
  'Please enter your email or phone': 'أدخل بريدك الإلكتروني أو رقم هاتفك',
  'Please fill all required fields': 'أكمل جميع الحقول المطلوبة',
  'Please select Date Range For Search': 'اختر فترة التاريخ للبحث',
  'Please select Employee or Date Range': 'اختر موظفاً أو فترة تاريخ',
  'Please select Reference Type': 'اختر نوع المرجع',
  'Procedure Deleted Successfully': 'تم حذف الإجراء بنجاح',
  'Procedures Saved Successfully': 'تم حفظ الإجراءات بنجاح',
  'Question Deleted Successfully': 'تم حذف السؤال بنجاح',
  'Questions Saved Successfully': 'تم حفظ الأسئلة بنجاح',
  'Registration failed, please try again': 'فشل التسجيل، حاول مرة أخرى',
  'Role-Permission created successfully': 'تم إنشاء صلاحية الدور بنجاح',
  'Role-Permission deleted successfully': 'تم حذف صلاحية الدور بنجاح',
  'Role-Permission updated successfully': 'تم تحديث صلاحية الدور بنجاح',
  'Saved Successfully': 'تم الحفظ بنجاح',
  'Skill Deleted Successfully': 'تم حذف المهارة بنجاح',
  'Skills saved successfully': 'تم حفظ المهارات بنجاح',
  'Standard invoices awaiting ZATCA clearance were excluded from print.': 'استُبعدت من الطباعة الفواتير القياسية التي تنتظر اعتماد هيئة الزكاة.',
  'Status Changed Successfully': 'تم تغيير الحالة بنجاح',
  'Status Employee Changed': 'تم تغيير حالة الموظف',
  'Status Updated Successfully': 'تم تحديث الحالة بنجاح',
  'Stock movement posted': 'تم ترحيل حركة المخزون',
  'Tax type deleted successfully': 'تم حذف نوع الضريبة بنجاح',
  'Tax type status updated successfully': 'تم تحديث حالة نوع الضريبة بنجاح',
  'Toggled status': 'تم تغيير الحالة',
  'Unexpected Error Occurred. Please Try Again Later.': 'حدث خطأ غير متوقع. حاول مرة أخرى لاحقاً.',
  'Updated Absent Successfully': 'تم تحديث الغياب بنجاح',
  'Updated Deduction Successfully': 'تم تحديث الخصم بنجاح',
  'Updated successfully': 'تم التحديث بنجاح',
  'User added successfully': 'تمت إضافة المستخدم بنجاح',
  'Vacation request updated successfully': 'تم تحديث طلب الإجازة بنجاح',
  'Write why the applicant did not pass.': 'اكتب سبب عدم اجتياز المتقدم.',
  'Your Answers Saved Successfully': 'تم حفظ إجاباتك بنجاح',
  'Your Application Saved': 'تم حفظ طلبك',
  'Link copied to clipboard!': 'تم نسخ الرابط!',
  'Please login first to access this page': 'سجّل الدخول أولاً للوصول إلى هذه الصفحة',
  // common server replies
  'data added': 'تمت إضافة البيانات',
  'data Modified': 'تم تعديل البيانات',
  'Data added successfully': 'تمت إضافة البيانات بنجاح',
  'Data updated successfully': 'تم تحديث البيانات بنجاح',
  'Data deleted successfully': 'تم حذف البيانات بنجاح',
};

const normal = (s: string) => s.trim().replace(/\s+/g, ' ').toLowerCase();
const INDEX = new Map(Object.entries(AR).map(([en, ar]) => [normal(en), ar]));

/** The Arabic of a fixed English toast; the text itself when there is none. */
export function arabicToast(message: string | undefined): string | undefined {
  return message ? INDEX.get(normal(message)) ?? message : message;
}
